"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeWithoutPaymentConsumer = exports.MeWithoutPaymentProvider = exports.MeProvider = exports.MeConsumer = exports.MeWithoutPaymentContext = exports.MeContext = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const graphql_1 = require("../graphql");
const defaultProps = {};
exports.MeContext = react_1.default.createContext({});
exports.MeWithoutPaymentContext = react_1.default.createContext({});
const MeConsumer = exports.MeContext.Consumer;
exports.MeConsumer = MeConsumer;
const MeWithoutPaymentConsumer = exports.MeWithoutPaymentContext.Consumer;
exports.MeWithoutPaymentConsumer = MeWithoutPaymentConsumer;
const transformData = (data) => {
    let hasPaymentInfo = false;
    let hasSubscription = false;
    let defaultSource;
    let sources = [];
    let subscriptions = [];
    if (data.me.paymentInfo) {
        hasPaymentInfo = !!data.me.paymentInfo.defaultSource;
        hasSubscription = !!data.me.paymentInfo.subscriptions.data.length;
        defaultSource = data.me.paymentInfo.defaultSource || undefined;
        sources = data.me.paymentInfo.sources ? data.me.paymentInfo.sources.data : [];
        subscriptions = data.me.paymentInfo.subscriptions ? data.me.paymentInfo.subscriptions.data : [];
    }
    return {
        me: {
            ...data.me,
            hasPaymentInfo,
            hasSubscription,
            defaultSource,
            sources,
            subscriptions,
        },
    };
};
const MeProvider = ({ children }) => (react_1.default.createElement(graphql_1.MeData, null, ({ data: meData, loading, error, client, refetch }) => {
    const data = loading ? undefined : transformData(meData);
    const refetchData = () => refetch();
    return react_1.default.createElement(exports.MeContext.Provider, { value: { data, loading, error, client, refetchData } }, children);
}));
exports.MeProvider = MeProvider;
const MeWithoutPaymentProvider = ({ children }) => (react_1.default.createElement(graphql_1.MeWOPaymentData, null, ({ data: meData, loading, error, client, refetch }) => {
    const data = loading ? undefined : meData.me;
    const refetchData = () => refetch();
    return (react_1.default.createElement(exports.MeWithoutPaymentContext.Provider, { value: { data, loading, error, client, refetchData } }, children));
}));
exports.MeWithoutPaymentProvider = MeWithoutPaymentProvider;
